/**
 *
 * @module tokenClientConfiguration
 *
 */

import ServiceClientConfiguration from './../configuration/serviceClientConfiguration';

/**
 *
 * @class TokenClientConfiguration
 * @extends {ServiceClientConfiguration}
 *
 */
export default class TokenClientConfiguration extends ServiceClientConfiguration {

    /**
     *
     * @param {String} baseUrl
     * @param {Object} endpoints
     * @param {TokenClientExtrasMap} extras
     *
     */
    constructor(baseUrl, endpoints, extras) {

        super(baseUrl, endpoints);

        /**
         *
         * @access public
         * @type {TokenClientExtrasMap}
         *
         */
        this.extras = extras;

    }

}



// WEBPACK FOOTER //
// ./src/services/token/tokenClientConfiguration.js